// extracted by mini-css-extract-plugin
export var addButton = "_h0-0";
export var border = "_h0-8";
export var check = "_h0-h";
export var danger = "_h0-6";
export var dropdownContainer = "_h0-1";
export var editModalBody = "_h0-j";
export var footerContainer = "_h0-i";
export var fullWidth = "_h0-a";
export var hide = "_h0-9";
export var icon = "_h0-3";
export var input = "_h0-7";
export var inputFlex = "_h0-b";
export var inputWrapper = "_h0-c";
export var manualFocus = "_h0-5";
export var optionButton = "_h0-4";
export var pillWrapper = "_h0-e";
export var pointer = "_h0-2";
export var showOverflow = "_h0-f";
export var tagsFlex = "_h0-d";
export var xButton = "_h0-g";